import { render, staticRenderFns } from "./kiosk-re-pagination.vue?vue&type=template&id=31242b84&scoped=true&"
import script from "./kiosk-re-pagination.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-pagination.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-re-pagination.vue?vue&type=style&index=0&id=31242b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31242b84",
  null
  
)

export default component.exports